import { DataAccessTable } from "@interfaces/data-access";

interface TablesRawData {
  data: {
    tables: string[];
  }
}

interface TableDownloadUrlRawData {
  data: {
    query_id: string;
  }
}

export function transformTables(raw: unknown): DataAccessTable[] {
  const data = (raw as TablesRawData).data;

  return data.tables.map(name => ({
    name,
    friendlyName: name.split("_").map(
      s => s[0].toUpperCase() + s.slice(1)
    ).join(" "),
  }));
}

export function transformTableDownloadUrl(raw: unknown): string | null {
  const data = (raw as TableDownloadUrlRawData).data;
  const baseUrl = (window as any).apiBaseUrl;
  const endpoint = "/admin/data/query/download/";
  const queryId = data?.query_id;

  if (!baseUrl || !queryId) {
    return null;
  }

  return `${baseUrl}${endpoint}${queryId}`;
}

